import "./ProjectionMap.html";
import "./ProjectionMap.scss";

import "../AddSiteEquipment/AddSiteEquipmentComponent";
import "../EditMap/EditMapComponent";
import "../SelectedEquipment/SelectedEquipmentComponent";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import ProjectionMapComponentController from "./ProjectionMapComponentController";

export default class ProjectionMapComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            site: "=",
        };
        this.controller = ProjectionMapComponentController;
        this.templateUrl = "/App/Components/Site/DesignAndPlanning/ProjectionMap/ProjectionMap.html";
    }
}

module("mmManagePortal").component("mmProjectionMap", new ProjectionMapComponent());
